// Airport stations that get the "station-managed" pickup behaviour (estimate pre-fill in the
// pickup dialog, the audit disclaimer, and silent-apply on acceptance).
//
// The frontend identifies a station by its code STRING (tripDetails.branch), whereas the backend
// identifies it by numeric branch id (Config.StationManagedBranchIds: 1814=BLR, 1818=COK,
// 1820=HYD, 1825=MAA). Keep the two lists in sync when adding/removing a station.
export const STATION_MANAGED_BRANCHES = ["BLR", "COK", "HYD", "MAA"];
